/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from "react-i18next";
import SecondaryBtn from "../../common/form/SecondaryBtn";
import { Edit, GreenPointsInfo, GreenPointsProfile, SecondaryArr, Upload, UploadedProfile, Warn } from "../../common/svg/AllSvg";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import PrimaryInput from "../../common/form/PrimaryInput";
import SelectSecondaryComponent from "../../common/form/SelectSecondaryComponent";
import PrimaryTextarea from "../../common/form/PrimaryTextarea";
import { components } from "react-select";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";
import { useDispatch, useSelector } from "react-redux";
import { dataActions } from "../../../shared/store/data-Slice";
import { numberOnPaste } from "../../../shared/utils/numberOnPaste";
import { Bounce, ToastContainer } from "react-toastify";
import { errors } from "../../../shared/utils/errors";
import { authActions } from "../../../shared/store/auth-Slice";
import { storeCookie } from "../../../shared/utils/storeCookie";

const DropdownIndicator = (props: any) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <SecondaryArr />
      </components.DropdownIndicator>
    )
  );
};

const Profile = ({ type }: any) => {
  const lang: string = useSelector((state: any) => state.ui.lang);
  const user: any = useSelector((state: any) => state.auth.user);
  const { t } = useTranslation('common');
  const [img, setImg] = useState<string>("");
  const [imgErr, setImgErr] = useState<string>("");
  const [updImg, setUpdImg] = useState<boolean>(false);
  const [disImg, setDisImg] = useState<boolean>(false);
  const [data, setData] = useState<any>([])
  const [submit, setSubmit] = useState<boolean>(false);
  const [stateList, setStateList] = useState<any[]>([])
  const [edit, setEdit] = useState<boolean>(false)
  const [imgFocus, setImgFocus] = useState<boolean>(false)
  const [greenPoints, setGreenPoints] = useState<any>(null)
  const genders: any[] = [{ label: t("recruitment.profile.genders.male"), value: "male" }, { label: t("recruitment.profile.genders.female"), value: "female" }, { label: t("recruitment.profile.genders.other"), value: "other" }]
  const maritalStatus: any[] = [{ label: t("recruitment.profile.maritalStatus.unmarried"), value: "unmarried" }, { label: t("recruitment.profile.maritalStatus.married"), value: "married" }]
  const dispatch = useDispatch();

  const formik: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: !!data?.first_name ? data?.first_name : '',
      last_name: !!data?.last_name ? data?.last_name : '',
      email: !!data?.email ? data?.email : '',
      father_name: !!data?.profile?.father_name ? data?.profile?.father_name : '',
      gender: !!data?.profile?.gender ? data?.profile?.gender : 'male',
      dob: !!data?.profile?.dob ? data?.profile?.dob : '',
      marital_status: !!data?.profile?.marital_status ? data?.profile?.marital_status : 'unmarried',
      mobile_no: !!data?.profile?.mobile ? data?.profile?.mobile : '',
      address: !!data?.profile?.address ? data?.profile?.address : '',
      city: !!data?.profile?.city ? data?.profile?.city : '',
      state: (!!data?.profile?.state && Object?.keys(data?.profile?.state)?.length > 0) ? { label: data?.profile?.state?.name, value: data?.profile?.state?.id } : '',
      zipcode: !!data?.profile?.zipcode ? data?.profile?.zipcode : '',
      pic: ''
    },
    validationSchema: yup.object().shape({
      first_name: yup.string().required(t("auth.form.validation.first_name")),
      last_name: yup.string().required(t("auth.form.validation.last_name")),
      father_name: yup.string().matches(/^[A-Za-z\s]+$/, t("contact_us.form.alpha_char_err")).required(t("recruitment.profile.err.father_name")),
      gender: yup.string().required(t("recruitment.profile.err.gender")),
      dob: yup.date().required(t("recruitment.profile.err.dob")),
      marital_status: yup.string().required(t("recruitment.profile.err.marital_status")),
      mobile_no: yup.number().test('len', t("recruitment.profile.err.valid_mobile_no"), (val: any) => val && val.toString().length === 10).required(t("recruitment.profile.err.mobile_no")),
      email: yup.string().email(t("auth.form.validation.wrong_email")).required(t("auth.form.validation.email")),
      address: yup.string().required(t("recruitment.profile.err.address")),
      city: yup.string().required(t("recruitment.profile.err.city")),
      state: yup.object().required(t("recruitment.profile.err.state")),
      zipcode: yup.string().matches(/^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/, t("recruitment.profile.err.valid_zipcode")).required(t("recruitment.profile.err.zipcode"))
    }),
    onSubmit: async (values: any) => {
      //submit
      try {
        if (!!!img) {
          setImgErr(t("recruitment.profile.err.profile_img"))
          return
        }

        setSubmit(true)
        const formData = new FormData();
        formData.append("first_name", values?.first_name);
        formData.append("last_name", values?.last_name);
        formData.append("email", values?.email);
        formData.append("father_name", values?.father_name);
        formData.append("gender", values?.gender);
        formData.append("dob", values?.dob);
        formData.append("marital_status", values?.marital_status);
        data?.profile?.mobile?.toString() !== values?.mobile_no?.toString() && formData.append("phone", values?.mobile_no);
        formData.append("address", values?.address);
        formData.append("city", values?.city);
        formData.append("state", values?.state?.value);
        formData.append("zipcode", values?.zipcode);
        updImg && formData.append("pic", values?.pic);

        const res: any = await useAxios.post(`/${(!!lang ? lang : "en") + url?.passenger_upd}`, formData);

        if (res && res?.status === 200) {
          setSubmit(false);
          getData();

          if (data?.profile?.mobile?.toString() !== values?.mobile_no?.toString()) {
            localStorage.setItem("field_value", values?.mobile_no)
            localStorage.setItem("auth_type", "update_profile")
            localStorage.setItem("field", "mobile")
            localStorage.setItem("verify_type", "profile-verify")
            dispatch(dataActions.setVerifyEmailOpen(true))
          }
        }
      } catch (error: any) {
        errors(error)
        setSubmit(false)
        console.error("error while create profile", error);
      }
    }
  });

  const handleSubmit = () => {
    if (!!!img) {
      setImgErr(t("recruitment.profile.err.profile_img"))
      return
    }
  }

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImgErr("")
    let files: any = e.target.files;
    if (!files) return;

    if (!files[0].name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
      setImgErr(t("passenger.lost_found.report_form.validation.valid_file"));
      return;
    }

    if (files[0].size > (5 * 1000 * 1024)) {
      setImgErr(t("passenger.lost_found.report_form.validation.size_err"));
      return;
    }

    const pImg: any = new Image();
    pImg.src = URL.createObjectURL(files[0]);
    pImg.onload = async () => {
      const width: any = await pImg.naturalWidth;
      const height: any = await pImg.naturalHeight;
      if (width > 300 && height > 300) {
        setImgErr(t("passenger.lost_found.report_form.validation.img_size_err"));
        return;
      } else {
        setDisImg(true)
        setImg(URL.createObjectURL(files[0]));
        setUpdImg(true)
        formik.setFieldValue("pic", files[0]);
        (document.getElementById('pic') as any).value = '';
        setDisImg(false)
      }
    }

  }

  const getState = async () => {
    try {
      const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.state}`);

      if (res && res.status === 200) {
        res?.data?.results?.length > 0 && setStateList(res?.data?.results?.map((item: any) => ({ label: item?.text, value: item?.id })))
      }
    } catch (error) {
      console.error("error while fetching state", error);
    }
  }

  const getData = async () => {
    try {
      const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.passenger_get}`);

      if (res && res.status === 200) {
        setData(res?.data)
        !!res?.data?.profile?.pic && setImg(res?.data?.profile?.pic)

        let profileUser: any = { ...user }
        profileUser.first_name = !!res?.data?.first_name ? res?.data?.first_name : profileUser?.first_name
        profileUser.last_name = !!res?.data?.last_name ? res?.data?.last_name : profileUser?.last_name
        profileUser.phone = !!res?.data?.profile?.mobile ? res?.data?.profile?.mobile : profileUser?.phone
        profileUser.email = !!res?.data?.email ? res?.data?.email : profileUser?.email
        profileUser.username = !!res?.data?.email ? res?.data?.email : profileUser?.email

        storeCookie({ data: profileUser }, null)
        dispatch(authActions.userDetail(profileUser))
        setGreenPoints(res?.data?.carbon_points);
      }
    } catch (error) {
      console.error("error while fetching user details", error);
    }
  }

  useEffect(() => {
    if (!!lang) {
      getState();
      getData();
    }
  }, [lang])

  const handleEdit = () => {
    if (edit) {
      handleSubmit();
      formik?.handleSubmit();
    } else {
      setEdit(true)
    }
  }

  useEffect(() => {
    if (edit) {
      const handleBeforeUnload = (event: any) => {
        event.preventDefault();
        event.returnValue = '';
      };
      window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
  }, [edit]);

  return (
    <div className="flex flex-col w-full">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />

      <div className="w-full flex msm:items-center msm:justify-between msm:flex-row flex-col pb-[20px] px-[15px] md:p-[30px] xlx:p-[35px] border-b border-primary border-opacity-[0.2] gap-[15px]">
        <div className="flex flex-col gap-[5px]">
          <h3 className="text-primaryText dark:text-white font-semibold">{t("recruitment.profile.edit_profile.title")}</h3>
          <h6 className="text-blackDull dark:text-textBlackDull font-medium">{t("profile.profile_desc")}</h6>
        </div>

        <div className="flex xs:items-center gap-[15px] xs:flex-row flex-col">
          {type === "passenger" &&
            <div className="min-h-[39px] flex items-center relative pl-[70px] xlx:pl-[80px] pr-[15px] gap-[20px] xlx:gap-[40px] rounded-[10px] bg-[#36BD74]">
              <div className="absolute top-[-1px] msm:top-[-0.6px] xl:top-[-0.3px] left-0 bottom-0"><GreenPointsProfile /></div>
              <p className="text-white font-semibold text-[12px] whitespace-nowrap uppercase">{t("go_green_points.title")}</p>
              <div className="flex items-center gap-[8px]">
                <h5 className="text-white font-bold text-[16px]">{!!greenPoints ? greenPoints : 0}</h5>
                <button aria-label={t("aria_label.go_green_points")} title={t("aria_label.go_green_points")} className="min-w-[14px] rounded-full hover:shadow-[0_0_0_1.5px_#4AFFB4] focus:shadow-[0_0_0_1.5px_#4AFFB4]" onClick={() => { dispatch(dataActions.setGoGreenPointsOpen(true)); }}><GreenPointsInfo /></button>
              </div>
            </div>
          }
          <SecondaryBtn css={`!rounded-[6px] ${!edit ? "px-[12px]" : "px-[24px]"} font-semibold !h-[35px] !gap-[8px] !text-base`} title={!edit ? t("profile.edit") : t("recruitment.hr.create_ad.field.save")} leftIcon={!edit && <Edit className="w-[17px] h-[17px] fill-white" />} onClick={handleEdit} disabled={edit ? (disImg || submit) : false} />
        </div>
      </div>

      <div className="flex gap-[40px] xlx:gap-[50px] py-[20px] px-[15px] md:p-[30px] xlx:px-[35px] xlx:py-[50px] xsm:flex-row flex-col">
        {/* profile photo */}
        <div className="flex flex-col xsm:items-center gap-[15px] min-w-[120px]">
          <div className="flex flex-col xsm:items-center gap-[4px]">
            <div className="bg-[#F5F5F5] dark:bg-bgDark rounded-full w-[100px] h-[100px] flex items-center justify-center relative">
              {!!img ? <img src={img} alt="pic" className="w-[100px] h-[100px] object-contain rounded-full" title='' /> : <UploadedProfile className="stroke-primary dark:stroke-bgPrimaryDark" />}

              {!!img && <div className="absolute right-0 bottom-0">
                <div className={`relative min-w-[28px] h-[28px] flex items-center justify-center border border-[#E2E2E2] bg-white shadow-[0px_9.045px_31.656px_-6.783px_rgba(24,39,75,0.12),0px_20.35px_99.49px_-4.522px_rgba(24,39,75,0.14)] rounded-full ${imgFocus && "focus:shadow-[0_0_0_3px_#059db25e]"} ${!edit ? "opacity-[0.7]" : "hover:shadow-[0_0_0_3px_#059db25e]"}`}>
                  <input type="file" id="pic" onChange={handleUpload} className="opacity-0 absolute top-0 left-0 right-0 bottom-0 z-[1] w-full h-full" title='' multiple={false} onFocus={() => setImgFocus(true)} onBlur={() => setImgFocus(false)} disabled={!edit} />
                  <Edit className="fill-primary" aria-label={t("aria_label.edit_profile_img")} title={t("aria_label.edit_profile_img")} disabled={!edit} />
                </div>
              </div>}
            </div>

            {(!!imgErr && !!img) && <div className="flex gap-[6px] items-start max-w-[110px]"><Warn />
              <span className="text-danger dark:text-darkDanger text-xs font-medium">{imgErr}</span>
            </div>}
          </div>
          {!!!img && <div className="relative h-fit w-fit">
            <input type="file" id="pic" onChange={handleUpload} className="opacity-0 absolute top-0 left-0 right-0 bottom-0 z-[1] w-full h-full" title='' multiple={false} disabled={!edit} onFocus={() => setImgFocus(true)} onBlur={() => setImgFocus(false)} />

            <div className="flex flex-col gap-[4px]">
              <div className={`flex items-center gap-[10px] ${!edit ? "opacity-[0.7]" : "hover:underline"} text-primary ${imgFocus && "underline"}`}>
                <Upload />
                <h6 className="text-primary font-semibold">{t("recruitment.profile.field.upload_pic")}</h6>
              </div>
              {!!imgErr && <div className="flex gap-[6px] items-start max-w-[110px]"><Warn />
                <span className="text-danger dark:text-darkDanger text-xs font-medium">{imgErr}</span>
              </div>}
            </div>
          </div>}
        </div>

        <div className="w-full lgl:w-[580px] h-full flex flex-col gap-[15px] xsm:gap-[20px] xlx:gap-[30px]">
          <div className="flex items-center gap-[8px] xlx:gap-[12px] mt-[10px] xlx:mt-[20px]">
            <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("profile.personal_details")}</h5>
            <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
          </div>

          <div className="grid w-full grid-cols-1 msm:grid-cols-2 gap-[15px] xlx:gap-[20px]">
            <div className="flex flex-col gap-[4px]">
              <PrimaryInput title={`${t("recruitment.profile.field.first_name")}*`} name="first_name" type="text" placeholder={t("recruitment.profile.field.first_name")} value={formik?.values?.first_name} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
              {formik?.touched?.first_name && formik?.errors?.first_name && <div className="flex gap-[6px] items-start"><Warn />
                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.first_name}</span>
              </div>}
            </div>

            <div className="flex flex-col gap-[4px]">
              <PrimaryInput title={`${t("recruitment.profile.field.last_name")}*`} name="last_name" type="text" placeholder={t("recruitment.profile.field.last_name")} value={formik?.values?.last_name} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
              {formik?.touched?.last_name && formik?.errors?.last_name && <div className="flex gap-[6px] items-start"><Warn />
                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.last_name}</span>
              </div>}
            </div>
          </div>

          <div className="grid w-full grid-cols-1 msm:grid-cols-2 gap-[15px] xlx:gap-[20px]">
            <div className="flex flex-col gap-[4px]">
              <PrimaryInput title={`${t("recruitment.profile.field.father_name")}*`} name="father_name" type="text" placeholder={t("recruitment.profile.field.father_name")} value={formik?.values?.father_name} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
              {formik?.touched?.father_name && formik?.errors?.father_name && <div className="flex gap-[6px] items-start"><Warn />
                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.father_name}</span>
              </div>}
            </div>

            <div className="flex flex-col gap-[4px]">
              <PrimaryInput title={`${t("recruitment.profile.field.dob")}*`} name="dob" type="date" placeholder={t("recruitment.profile.field.dob")} value={formik?.values?.dob} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
              {formik?.touched?.dob && formik?.errors?.dob && <div className="flex gap-[6px] items-start"><Warn />
                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.dob}</span>
              </div>}
            </div>
          </div>


          <div className="grid w-full grid-cols-1 msm:grid-cols-2 gap-[15px] xlx:gap-[20px]">
            <div className="flex flex-col gap-[4px]">
              <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.gender")}*`}</h6>

              <div className="flex items-center gap-[10px]">
                {Array.isArray(genders) && genders?.map((item: any, index: number) => (
                  <button key={index} className={`${formik?.values?.gender === item?.value ? "border border-primary bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border border-blackDull bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[10px] h-[35px] xlx:h-[40px] px-[12px] text-sm leading-snug font-normal disabled:opacity-[0.7] cursor-pointer disabled:shadow-none disabled:dark:shadow-none`} onClick={() => formik.setFieldValue("gender", item?.value)} disabled={!edit}>{item?.label}</button>
                ))}
              </div>
            </div>

            <div className="flex flex-col gap-[4px]">
              <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.marital_status")}*`}</h6>

              <div className="flex items-center gap-[10px]">
                {Array.isArray(maritalStatus) && maritalStatus?.map((item: any, index: number) => (
                  <button key={index} className={`${formik?.values?.marital_status === item?.value ? "border border-primary bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border border-blackDull bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[10px] h-[35px] xlx:h-[40px] px-[12px] text-sm leading-snug font-normal disabled:opacity-[0.7] cursor-pointer disabled:shadow-none disabled:dark:shadow-none`} onClick={() => formik.setFieldValue("marital_status", item?.value)} disabled={!edit}>{item?.label}</button>
                ))}
              </div>
            </div>
          </div>

          <div className="flex items-center gap-[8px] xlx:gap-[12px] mt-[10px] xlx:mt-[20px]">
            <h5 className="text-primaryText dark:text-white font-bold whitespace-nowrap">{t("profile.contact_details")}</h5>
            <div className="border-b border-primaryText dark:border-white w-full border-opacity-[0.6]"></div>
          </div>

          <div className="grid w-full grid-cols-1 msm:grid-cols-2 gap-[15px] xlx:gap-[20px]">
            <div className="flex flex-col gap-[4px]">
              <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.mobile_no")}*`}</h6>
              <div className="flex items-center gap-[10px] w-full">
                <input className={`flex items-center justify-center px-[7px] w-[35px] xlx:w-[40px] h-[35px] xlx:h-[40px] rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] text-blackDull text-sm leading-snug disabled:opacity-[0.7] dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull disabled:hover:bg-[#F5F5F5] disabled:dark:hover:bg-bgDark`} defaultValue="+91" disabled autoComplete="off" />
                <input className="placeholder:text-blackDull w-full rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] h-[35px] xlx:h-[40px] px-[15px] xlx:px-[17px] text-blackDull text-sm leading-snug disabled:opacity-[0.7] dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull disabled:hover:bg-[#F5F5F5] disabled:dark:hover:bg-bgDark" type="number" name="mobile_no" placeholder={t("recruitment.profile.field.mobile_no")} autoComplete="off" value={formik?.values?.mobile_no} onBlur={formik?.handleBlur} onChange={formik?.handleChange} onFocus={(e: any) => e.target.addEventListener("wheel", function (e: any) { e.preventDefault() }, { passive: false })}
                  onKeyDown={(e: any) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()} onPaste={(e: any) => numberOnPaste(e)} disabled={!edit} />
              </div>
              {formik?.touched?.mobile_no && formik?.errors?.mobile_no && <div className="flex gap-[6px] items-start"><Warn />
                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.mobile_no}</span>
              </div>}
            </div>

            <div className="flex flex-col gap-[4px]">
              <PrimaryInput title={`${t("recruitment.profile.field.email")}*`} name="email" type="email" placeholder={t("recruitment.profile.placehoder.email")} value={formik?.values?.email} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
              {formik?.touched?.email && formik?.errors?.email && <div className="flex gap-[6px] items-start"><Warn />
                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.email}</span>
              </div>}
            </div>
          </div>

          <div className="flex flex-col gap-[4px]">
            <PrimaryTextarea title={`${t("recruitment.profile.field.address")}*`} placeholder={t("recruitment.profile.placehoder.address")} name="address" rows="4" value={formik?.values?.address} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
            {formik?.touched?.address && formik?.errors?.address && <div className="flex gap-[6px] items-start"><Warn />
              <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.address}</span>
            </div>}
          </div>

          <div className="grid w-full grid-cols-1 msm:grid-cols-3 gap-[15px] xlx:gap-[20px]">
            <div className="flex flex-col gap-[4px]">
              <PrimaryInput title={`${t("recruitment.profile.field.city")}*`} type="text" name="city" placeholder={t("recruitment.profile.field.city")} value={formik?.values?.city} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
              {formik?.touched?.city && formik?.errors?.city && <div className="flex gap-[6px] items-start"><Warn />
                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.city}</span>
              </div>}
            </div>

            <div className="flex flex-col gap-[4px]">
              <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.state")}*`}</h6>
              <SelectSecondaryComponent
                options={stateList}
                name="state"
                placeholder={t("recruitment.profile.placehoder.state")}
                isSearchable={false}
                arrow={true}
                components={{ DropdownIndicator }}
                onChange={(e: any) => formik.setFieldValue("state", e)}
                onBlur={(e: any) => formik.setFieldTouched("state", e)}
                value={!!formik.values.state ? stateList?.find((item: any) => item?.value === formik.values.state?.value) : formik.values.state}
                isDisabled={!edit}
              />
              {formik?.touched?.state && formik?.errors?.state && <div className="flex gap-[6px] items-start"><Warn />
                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.state}</span>
              </div>}
            </div>

            <div className="flex flex-col gap-[4px]">
              <PrimaryInput title={`${t("recruitment.profile.field.zipcode")}*`} type="number" name="zipcode" placeholder={t("recruitment.profile.field.zipcode")} value={formik?.values?.zipcode} onBlur={formik?.handleBlur} onChange={formik?.handleChange} exceptThisSymbols={["e", "E", "+", "-", "."]} disabled={!edit} />
              {formik?.touched?.zipcode && formik?.errors?.zipcode && <div className="flex gap-[6px] items-start"><Warn />
                <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.zipcode}</span>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;